module.exports = __webpack_public_path__ + "static/media/icons8-double-tick.efd13f90.svg";